<template>
  <div :style="cellStyle" class="cell-block cell-block-suspended-row">
    <div v-tooltip="tooltipConfig" :class="['cell-tooltip', 'cell-suspended-row']"></div>
  </div>
</template>

<script>
import format from "../../../mixins/format";

export default {
  mixins: [format],

  computed: {
    tooltipContent() {
      return `<div>Suspended</div>`;
    },

    tooltipConfig() {
      return {
        content: this.tooltipContent,
        classes: ["cell-small-tooltip-theme-suspended-row"],
        placement: "top-start",
      };
    },

    cellStyle() {
      const length = 13;

      return {
        width: `calc(${length * 100.6}% + ${length + 1}px)`,
        height: "100%",
      };
    },
  },
};
</script>
